import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_REST_API_VSMS

export const show = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/company/vendor-key`,
  })

  return response?.data
}
